import React, { useEffect, useState } from "react";

import Loader from "./Loader";
import QuizNavigation from "./QuizNavigation";
import QuizStepIndicators from "./QuizStepIndicators";
import QuizQ1 from "./QuizQ1";
import QuizQ2 from "./QuizQ2";
import QuizQ3 from "./QuizQ3";
import QuizQ4 from "./QuizQ4";
import QuizQ5 from "./QuizQ5";
import QuizQ6 from "./QuizQ6";
import QuizQ7 from "./QuizQ7";
import QuizQ8 from "./QuizQ8";
import QuizQ9 from "./QuizQ9";
import QuizQ10 from "./QuizQ10";
import QuizQ11 from "./QuizQ11";
import QuizQ12 from "./QuizQ12";
import QuizQ13 from "./QuizQ13";
import QuizQ14 from "./QuizQ14";
import { useSaveQuiz } from "../services/hooks/useSaveQuiz";
import { useAccount } from "../services/hooks/useAccount";
import { useSnackbar } from "../services/hooks/useSnackbar";
import { useAuth } from "../services/hooks/useAuth";
import { useCart } from "../services/hooks/useCart";
import { useRedirect } from "../services/hooks/useRedirect";
import { useQuiz } from "../services/hooks/useQuiz";
import scrollToTop from "../util/scrollToTop";

export default React.memo(function QuizContainer() {
  const { user, isSubscribed } = useAuth();
  const [currentQuizStep, setCurrentQuizStep] = useState(1);
  const { fetchPreferences } = useAccount();
  const { cartHasSubscription } = useCart();

  const { isSavingQuiz, saveQuiz, saveQuizError, savedQuiz } = useSaveQuiz();
  const { setShouldSaveForNewUser } = useQuiz();

  const { redirect } = useRedirect();

  const { addSnackbar } = useSnackbar();

  const totalSteps = 14;

  const onClickStepIndicator = (step) => {
    if (step >= 1 && step <= totalSteps) {
      setCurrentQuizStep(step);
    }
  };

  const onClickBack = () => {
    setCurrentQuizStep((prevQuizStep) => prevQuizStep - 1);
  };

  const onClickNext = () => {
    setCurrentQuizStep((prevQuizStep) => prevQuizStep + 1);
  };

  const onClickSave = () => {
    if (user) {
      saveQuiz();
    } else {
      setShouldSaveForNewUser({
        shouldSaveForNewUser: true,
      });
    }

    if (cartHasSubscription) {
      redirect("/checkout");
    } else if (!user) {
      redirect("/register");
    }
  };

  useEffect(() => {
    scrollToTop();
  }, [currentQuizStep]);

  useEffect(() => {
    if (saveQuizError) {
      addSnackbar(saveQuizError, {
        type: "danger",
      });
    }
  }, [saveQuizError]);

  useEffect(() => {
    if (savedQuiz) {
      fetchPreferences();
    }
  }, [savedQuiz]);

  useEffect(() => {
    if (savedQuiz) {
      if (!cartHasSubscription) {
        if (!isSubscribed) {
          redirect("/subscribe");
        } else {
          redirect("/account");
        }
      }
    }
  }, [cartHasSubscription, savedQuiz, isSubscribed]);

  if (isSavingQuiz || savedQuiz) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-12 mt-12">
            <p className="text-center">
              We're saving your preferences and personalizing your Chic Beauty
              Box experience
            </p>

            <Loader />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="container">
      <div className="row">
        <div className="col-12">
          {currentQuizStep === 1 && (
            <React.Fragment>
              <h3 className="mt-5 mb-8 text-center">
                Personalize your beauty experience
              </h3>
              <p className="text-center mb-5 mb-md-3">
                Tell us about yourself to help us personalize your Chic Beauty
                Box subscription
              </p>
            </React.Fragment>
          )}

          <QuizStepIndicators
            currentStep={currentQuizStep}
            totalSteps={totalSteps}
            onClickStepIndicator={onClickStepIndicator}
          />
        </div>
      </div>

      <div className="quiz">
        <QuizQ1 isActive={currentQuizStep === 1} />
        <QuizQ2 isActive={currentQuizStep === 2} />
        <QuizQ3 isActive={currentQuizStep === 3} />
        <QuizQ4 isActive={currentQuizStep === 4} />
        <QuizQ5 isActive={currentQuizStep === 5} />
        <QuizQ6 isActive={currentQuizStep === 6} />
        <QuizQ7 isActive={currentQuizStep === 7} />
        <QuizQ8 isActive={currentQuizStep === 8} />
        <QuizQ9 isActive={currentQuizStep === 9} />
        <QuizQ10 isActive={currentQuizStep === 10} />
        <QuizQ11 isActive={currentQuizStep === 11} />
        <QuizQ12 isActive={currentQuizStep === 12} />
        <QuizQ13 isActive={currentQuizStep === 13} />
        <QuizQ14 isActive={currentQuizStep === 14} />

        <QuizNavigation
          onClickBack={onClickBack}
          onClickNext={onClickNext}
          onClickSave={onClickSave}
          currentStep={currentQuizStep}
          totalSteps={totalSteps}
        />
      </div>
    </div>
  );
});
